<script>
  // The backtest results panel is now a thin wrapper over the SHARED PerformancePanel (U7). It passes the
  // backtest-specific no-data copy so the Backtester renders byte-identically to before the lift; the metric
  // cards + trades table now come from components/shared/, fed the neutral result shape (U2).
  import PerformancePanel from '../shared/PerformancePanel.svelte';

  // The BacktestResult as the API serializes it (camelCase) — now the neutral StrategyPerformanceResult shape.
  export let result = null;
</script>

<PerformancePanel
  {result}
  showUnfilledBanner={true}
  noDataTitle="No (or insufficient) market data for this selection."
  noDataBody="The backtest completed, but there isn't enough price history for the chosen symbol, window, and frequency to produce meaningful results. Try a different symbol, a shorter/known window, or a coarser frequency."
/>
